<template>
	<div class="mobile-app-container">
		<div class="container-encuesta">
			<div class="inner-container-encuesta">
				<div class="circle-logo-container">
					<div class="circle-logo-img">
						<img :src="url_images + logos[0]">
					</div>
					<div class="license-name">
						<h4 id="titulo">{{ companieName }}</h4>
					</div>
				</div>
				<div class="main-message">
					<h4>Hola {{ name_client }}, Bienvenido</h4>
				</div>
				<div class="second-message">
					<h4>Ayúdanos a mejorar para ti.</h4>
					<h5>Cuentanos como ha sido tu experiencia y te daremos un descuento especial</h5>
				</div>
				<div class="container-options">
					<div class="option-1" @click="border(true)" id="like">
						<img src="https://admin.vinapp.co/like.png">
					</div>
					<div class="option-2 border" @click="border(false)" id="dislike">
						<img src="https://admin.vinapp.co/dislike.png">
					</div>
				</div>
				<div class="text-area" v-show="form.estado == false">
					<textarea placeholder="Mensaje" v-model="form.observation"></textarea>
				</div>
				<div class="card-body" style="padding-top: 20px;">
          <button v-bind:style="{backgroundColor : color_botones}" @click="saveQrSurvey()" class="boton-finalizar">Finzalizar Encuesta</button>
        </div> 
			</div>
		</div>
	</div>
</template>
<style scoped>

		@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

		*{
			padding: 0;
			margin: 0;
			box-sizing: border-box;
		}

		*:focus{
			outline: none !important;
		}

		.container-encuesta{
			width: 100%;
			height: 100vh;
			background: #f7f7f7;
			display: block;
		}

		.circle-logo-container{
			width: 100%;
			padding: 50px 10px 10px 10px;
		}

		.circle-logo-img{
			width: 110px;
			height: 110px;
			border-radius: 50%;
			border: 5px solid #fff;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 5px;
			margin: 0 auto;
			background: #fff;
		}

		.circle-logo-img img{
			width: 100%;
			height: auto;
		}

		.license-name{
			width: 100%;
			height: auto;
			text-align: center;
			padding: 20px 0px 10px 0px;
		}

		.license-name h4{
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
			font-size: 23px;
		}

		.main-message{
			width: 100%;
			height: auto;
			text-align: center;
			padding: 10px 0px 0px 0px;
		}

		.main-message h4{
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
			font-size: 19px;
		}

		.second-message{
			width: 100%;
			height: auto;
			text-align: center;
			padding: 25px 0px 10px 0px;
		}

		.second-message h4{
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
			font-size: 17px;
			padding-bottom: 15px;
		}

		.second-message h5{
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
			font-size: 16px;
		}

		.container-options{
			width: 100%;
			height: auto;
			padding: 40px 0px 40px 0px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.option-1{
			background: #fff;
			width: 30%;
			border-radius: 10px;
			padding: 25px;
			display: flex;
			justify-content: center;
			align-items: center;
			box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
			margin-right: 30px;
		}

		.option-1 img{
			width: 100%;
			height: auto;
		}

		.option-2{
			background: #fff;
			width: 30%;
			border-radius: 10px;
			padding: 25px;
			display: flex;
			justify-content: center;
			align-items: center;
			box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
		}

		.option-2 img{
			width: 100%;
			height: auto;
		}

		.boton-finalizar{
	    border: none;
	    outline: 0;    
	    color: white;    
	    text-align: center;
	    cursor: pointer;    
	    font-size: 16px;
	    font-weight: 600;
	    padding-left: 25px;
	    padding-right: 25px;
	    padding-top: 7px;
	    padding-bottom:7px;
	    font-family: FontAwesome;
	    font-family: "Font Awesome 5 Free";
	    border-radius: 10px; 
	    width: 95%;   
	  } 

		.send-button{
			width: 90%;
			margin: 0 auto;
			font-family: 'Poppins', sans-serif;
			font-size: 19px;
			color: #fff;
			background: #002B5C;
			padding: 12px 0px;
			position: absolute;
			bottom: 40px;
			left: 0;
			right: 0;
			border: none;
			border-radius: 5px;
		}

		.text-area{
			width: 100%;
			height: auto;
			padding: 15px 0px;
			text-align: center;
		}

		.text-area textarea{
			width: 85%;
			height: 80px;
			border: none;
			padding: 15px;
			font-size: 16px;
			box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
		}

		::placeholder{
			color: #565656 !important;
			font-family: 'Poppins', sans-serif;
		}

		.border{
			border: 4px solid #002B5C !important;
		}


































		.spacer{
			width: 100%;
			margin-bottom: 20px;
		}

		.custom-1{
			background: #66CE9B !important;
		}

		.custom-2{
			background: #A8D5F2 !important;
		}

		.custom-3{
			background: #F87BA1 !important;
		}

		.custom-4{
			background: #04BABC !important;
		}

		.finish-payment{
			width: 100%;
			height: 90vh;
			overflow-y: auto;
			background: #FAF9FF;
			display: block;
		}

		.step-container{
			width: 100%;
			height: auto;
			padding: 35px 20px 8px 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: nowrap;
		}

		.step-container hr{
			height: 5px;
			background:#565656;
			opacity: .5;
			width: 15%;
		}

		.single-step{
			text-align: center;
		}

		.last i{
			color: transparent !important;
			border: 3px solid #04BABC;
			background: transparent !important;
		}

		.single-step i{
			background: #04BABC;
			color: #fff;
			padding: 10px;
			border-radius: 50%;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			font-size: 16px;
			margin: 0 auto;
		}

		.names{
			width: 100%;
			display: flex;
			justify-content: space-between;
			padding: 0px 35px;
			margin-bottom: 20px;
		}

		.names h4{
			font-size: 17px;
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.basic-data{
			width: 90%;
			background: #fff;
			height: auto;
			border-radius: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			margin: 0 auto;
			padding: 25px 20px; 
		}

		.basic-data h4{
			font-size: 18px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.basic-data h5{
			font-size: 16px;
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
			margin-top:  5px;
		}

		.basic-data span{
			font-weight: 600;
		}

		.container-button{
			width: 100%;
			padding: 20px 0px 95px 0px;
			text-align: center;
		}

		.confirm{
			width: 90%;
			height: auto;
			margin: 0 auto;
			border: none;
			border-radius: 15px;
			padding: 15px 0px;
			background: #04BABC;
			color: #fff;
			font-family: 'Poppins', sans-serif;
			font-size: 18px;
			font-weight: 500;
		}

		.cart-detail{
			width: 100%;
			height: auto;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: nowrap;
		}

		.cart-image{
			width: 50px;
			height: 50px;
			text-align: center;
			background: #04BABC;
			border-radius: 50%;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.cart-image img{
			width: 45%;
			height: auto;
		}

		.cart-information{
			width: 85%;
			text-align: left;
			padding: 0px 15px;
		}

		.cart-information h4{
			font-size: 17px;
			font-weight: 500;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}


		.tortas-home-container{
			width: 100%;
			height: 90vh;
			overflow-y: auto;
			background: #FAF9FF;
			display: block;
		}

		.header-tortas{
			width: 100%;
			height: auto;
			background: #04BABC;
			padding: 20px 15px 40px 15px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: nowrap;
		}

		.input-search-tortas{
			width: 83%;
			text-align: center;
			background: rgba(255, 255, 255, .35);
			border-radius: 25px;
			text-align: left;
			padding: 13px 20px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: nowrap;
		}

		.cart-tortas{
			width: 15%;
			padding: 10px;
			text-align: center;
		}

		.cart-tortas img{
			width: 88%;
			height: auto;
		}

		.input-search-tortas i{
			color: #fff;
			font-size: 16px;
		}

		.input-search-tortas input{
			border: none;
			background: transparent;
			color: #fff;
			font-size: 17px;
			font-family: 'Poppins', sans-serif;
			padding: 0px 12px;
		}


		::placeholder{
			color: #fff;
		}

		.tortas-promotions{
			width: 100%;
			background: #FAF9FF;
			height: auto;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			margin-top: -22px;
    		white-space: nowrap;
    		overflow-y: hidden;
    		overflow-x: auto;
    		text-align: left;
			padding: 20px 15px;
		}

		.day-promo{
			width: 95%;
			height: 16vh;
			background: red;
			border-radius: 10px;
			display: inline-block;
			margin-right: 10px;
			background: url("https://cdn.shopify.com/s/files/1/1284/6493/files/slide_1.jpg?v=1530955057");
			background-size: cover;
			background-position: center center;
			background-repeat: no-repeat;
			box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
		}

		.day-promo-2{
			width: 95%;
			height: 16vh;
			background: red;
			border-radius: 10px;
			display: inline-block;
			margin-right: 10px;
			background: url("https://opencart.opencartworks.com/themes/so_cakeshop/image/cache/catalog/slideshow/home3/slide1-1903x850.jpg");
			background-size: cover;
			background-position: center center;
			background-repeat: no-repeat;
			box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
		}

		.circle-item{
			width: 70px;
			height: 70px;
			border-radius: 50%;
			background: #04A384;
			margin: 0 auto;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: nowrap;
			margin-bottom: 5px;
			box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
		}

		.circle-item img{
			width: 45% !important;
			height: auto;
		}

		.container-products{
			width: 100%;
			height: auto;
			text-align: left;
			padding: 10px 15px;
		}

		.container-products h4{
			font-size: 19px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.products-grid{
			width: 100%;
			padding: 10px 0px;
			height: auto;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
		}

		.single-product{
			width: 48%;
			background: #fff;
			border-radius: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			margin-bottom: 15px;
		}

		.single-product img{
			width: 100%;
			border-bottom-right-radius: 10px;
			border-bottom-left-radius: 10px;
			border-radius: 10px;
			max-height: 180px;
		}

		.hearth-icon{
			width: 100%;
			text-align: right;
			padding: 0px 20px;
			margin-top: -20px;
		}

		.hearth-icon i{
			background: #fff;
			color: #FF7BA2;
			padding: 10px;
			border-radius: 50%;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			font-size: 16px;
		}

		.metadata{
			width: 100%;
			text-align: left;
			padding: 0px 10px 20px 10px;
		}

		.metadata h5{
			font-size: 17px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.metadata h6{
			font-size: 14px;
			font-weight: 600;
			color: #FF7BA2;
			font-family: 'Poppins', sans-serif;
		}

		.all-products{
			width: 100%;
			height: 90vh;
			overflow-y: auto;
			background: #FAF9FF;
			display: block;
		}

		.header-products{
			width: 100%;
			height: auto;
			text-align: center;
			padding: 18px 0px;
			background: #04BABC;
		}

		.header-products h4{
			font-size: 19px;
			font-weight: 600;
			color: #fff;
			font-family: 'Poppins', sans-serif;
		}

		.inner-all-products{
			width: 100%;
			height: auto;
			display: block;
			padding: 10px 20px;
		}

		.single-list-product{
			width: 100%;
			background: #fff;
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: nowrap;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			margin-bottom: 10px;
		}

		.product-image{
			width: 28%;
		}

		.product-image img{
			width: 100%;
			height: auto;
		}

		.product-information{
			width: 72%;
			text-align: left;
			padding: 0px 10px;
		}

		.name-product{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0px 20px 0px 0px;
		}

		.name-product h4{
			font-size: 17px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.name-product i{
			background: #EC8B7A;
			color: #fff;
			padding: 10px;
			border-radius: 50%;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
			font-size: 14px;
		}

		.product-information h5{
			font-size: 16px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}


		.price{
			width: 100%;
			height: auto;
			text-align: left;
		}

		.price h4{
			color: #EC8B7A;
			font-family: 'Poppins', sans-serif;
			font-size: 21px;
			font-weight: 600;
		}





































		.mobile-app-container{
			width: 100%;
			height: auto;
			background: #FAF9FF;
			padding: 0;
			margin: 0;
		}

		.app-inner-container{
			width: 100%;
			height: auto;
			padding: 20px 15px;
		}

		.app-header{
			width: 100%;
			text-align: left;
			display: block;
		}

		.app-header h4{
			font-size: 27px;
			font-weight: 400;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.app-header h5{
			font-size: 25px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}


		.single-item-sale h6{
			font-size: 15px;
			font-weight: 500;
			color: #5D5C5C;
			font-family: 'Poppins', sans-serif;
			margin-top: 10px;
		}

		.search-container{
			width: 100%;
			height: auto;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			background: #F7F7F7;
			border-radius: 13px;
			margin-top: 16px;
			padding: 19px 16px;
		}


		.search-container input{
			width: 90%;
			background: transparent;
			border: none;
			font-family: 'Poppins', sans-serif;
			font-size: 17px;
			color: #B9B9B9;
		}

		.search-container i{
			color: #B9B9B9;
			font-size: 19px;
			margin-right: 15px;
		}

		

		.navigation-menu{
			background: #fff;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
			display: flex;
			justify-content: space-around;
			align-items: center;
			padding: 28px 10px;
			width: 100%;
			border-top-left-radius: 15px;
			border-top-right-radius: 15px;
			position: fixed;
			bottom: 0;
		}

		/*.navigation-menu i{
			color: #fff;
			opacity: .9;
			font-size: 21px;
		}*/

		.navigation-menu img{
			width: 8%;
		}

		.categories-container{
			width: 100%;
			text-align: left;
			display: block;
			padding: 5px 0px;
		}

		.categories-container h4{
			font-size: 19px;
			font-weight: 600;
			padding: 0px 15px;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.popular-container{
			width: 100%;
			text-align: left;
			display: block;
			padding: 20px 0px;
		}

		.popular-container h4{
			font-size: 22px;
			font-weight: 600;
			color: #565656;
			font-family: 'Poppins', sans-serif;
		}

		.popular-collection{
    		white-space: nowrap;
    		overflow-y: hidden;
    		overflow-x: auto;
    		text-align: left;
    		padding: 5px 0px;
		}

		.name-collection{
			background: #fff;
    		white-space: nowrap;
    		overflow-y: hidden;
    		overflow-x: auto;
    		text-align: left;
    		padding: 25px 0px;
		}

		.name-collection h4{
			margin-right: 13px;
    		display: inline-block;
    		font-size: 14px;
			font-weight: 500;
			color: #DCDCDC;
			font-family: 'Poppins', sans-serif;
		}

		.name-collection h4:nth-child(1){
			color:#EF7D00;
			font-weight: 600;
		}

		.category-collection{
    		white-space: nowrap;
    		overflow-y: hidden;
    		overflow-x: auto;
    		text-align: left;
    		padding: 10px 0px 0px 0px;
		}

		.category-item{
			width: 22%;
			text-align: center;
			margin-right: 15px;
    		display: inline-block;
		}

		.category-item h4{
			font-size: 16px;
			font-weight: 500;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.category-item img{
			width: 100%;
			height: auto;
		}

		.single-popular{
			width: 48%;
			border-radius: 10px;
			padding: 8px 8px 22px 8px;
			border: 1px solid #F5F5F5;
			margin-right: 15px;
    		display: inline-block;
    		box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
		}

		.single-popular img{
			width: 100%;
			height: auto;
			border-radius: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
		}

		.single-popular h4{
			font-size: 16px;
			font-weight: 600;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.single-popular h5{
			font-size: 14px;
			font-weight: 500;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}


		/*Estilos interna de busqueda*/

		.inner-container-search{
			width: 100%;
			height: auto;
			padding: 20px 15px;
		}

		.filter-collection{
    		white-space: nowrap;
    		overflow-y: hidden;
    		overflow-x: auto;
    		text-align: left;
    		padding: 25px 10px;
		}

		.filter-collection h4{
			margin-right: 13px;
    		display: inline-block;
    		font-size: 14px;
			font-weight: 500;
			color: #04BABC;
			border: 1px solid #04BABC;
			font-family: 'Poppins', sans-serif;
			background: transparent;
			padding: 9px 16px;
			border-radius: 19px;
		}

		.filter-collection h4:nth-child(1){
			background: #04BABC;
			color: #fff;
		}

		.all-results{
			width: 100%;
			height: auto;
			display: block;
			padding-top: 15px;
		}

		.single-search-item{
			width: 100%;
			border-radius: 10px;
			padding: 8px 8px 22px 8px;
			border: 1px solid #F5F5F5;
			margin-right: 15px;
    		display: inline-block;
    		box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
    		margin-bottom: 15px;
		}

		.single-search-item img{
			width: 100%;
			height: auto;
			border-radius: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
		}

		.name-price{
			width: 100%;
			height: auto;
			padding: 10px 12px 5px 12px;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.stars{
			width: 100%;
			height: auto;
			padding: 10px 12px 0px 12px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.stars i{
			color: #ECA834;
		}

		.stars h4{
			color: #B9B9B9;
			font-family: 'Poppins', sans-serif;
		}

		.icons-collection{
			width: 100%;
			height: auto;
			padding: 10px 12px 0px 12px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.icons-collection i{
			color: #EF7D00;
			margin-right: 3px;
		}

		.icons-collection h4{
			font-size: 14px;
			font-weight: 500;
			color: #B9B9B9;
			font-family: 'Poppins', sans-serif;
			margin-right: 10px;
		}

		.name-price h4{
			font-size: 18px;
			font-weight: 600;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.name-price h5{
			font-size: 17px;
			font-weight: 500;
			color: #6ECFAF;
			font-family: 'Poppins', sans-serif;
		}


		/*Estilos detalle*/

		.inner-container-detail{
			width: 100%;
			height: 90vh;
			padding: 20px 15px;
			display: block;
			overflow-y: auto;
		}


		.image-detail{
			width: 100%;
			height: auto;
			position: relative;
		}

		.image-detail img{
			width: 100%;
			height: auto;
			border-radius: 28px;
		}

		.back-button-container{
			background: #fff;
			padding: 15px;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			top: 15px;
			left: 18px;
		}

		.stars-detail{
			width: 100%;
			height: auto;
			padding: 5px 0px 0px 0px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.stars-detail i{
			color: #ECA834;
		}

		.stars-detail h4{
			color: #B9B9B9;
			font-family: 'Poppins', sans-serif;
			margin-left: 5px;
		}

		.service-name{
			width: 100%;
			text-align: left;
			padding-top: 20px;
		}

		.service-name h4{
			font-size: 23px;
			font-weight: 600;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.description{
			width: 100%;
			text-align: left;
			padding-top: 20px;
		}

		.description h4{
			font-size: 17px;
			font-weight: 600;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.description p{
			font-size: 15px;
			font-weight: 500;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.gallery-service{
			width: 100%;
			text-align: left;
			padding-top: 10px;
		}

		.gallery-service h4{
			font-size: 17px;
			font-weight: 600;
			color: #333333;
			font-family: 'Poppins', sans-serif;
		}

		.images-gallerys{
			width: 100%;
			height: auto;
			display: flex;
			justify-content: space-around;
			align-items: center;
			padding-top: 10px;
		}

		.images-gallerys img{
			width: 20%;
			border-radius: 15px;
			margin-right: 10px;
		}

		.option-button{
			width: 100%;
			height: auto;
			padding-top: 20px;
			padding-bottom: 95px;
			text-align: center;
		}

		.option-button button{
			width: 100%;
			background: #04BABC;
			color: #fff;
			border: none;
			cursor: pointer;
			padding: 18px 0px;
			border-radius: 28px;
			font-family: 'Poppins', sans-serif;
			font-size: 18px;
			font-weight: 500;
		}
</style>
<script>	
  import Vue from 'vue'
  import Vuesax from 'vuesax'
  import axios from 'axios';
  import { osName } from 'mobile-device-detect';
  import 'vuesax/dist/vuesax.css' //Vuesax styles
  export default {
		data() {
			return {
				id_client: this.$route.params.id,
				url: 'https://back.vinapp.co/api/company/post-data-company-qr-survey',
				url_images:null,
				redirect:'',
				name_client:"",
				companieName:"",
				logos:"",
				backgroundColor:"",
  			portadas: [],
  			color_botones: null,
  			form:{
  				id_companies:'',
					id_client:'',
					observation:'',
					estado:true
  			}
			}
		},      
		methods:{ 
			
      setupCompanieQuestions(){  
          var data = new FormData();
          data.append('id_client', this.id_client); 
  			axios.post(this.url,data)
  			.then(res => {
					if (res.data.statusCode == 200) {
						this.companieName = res.data.store.name;
            document.getElementById("titulo").style = `color:${res.data.store.color_letra}`;
						this.portadas = res.data.store.portadas;
            this.url_images = res.data.url_images;
            this.color_botones = res.data.store.color_letra;
            this.logos = res.data.store.logos;
            this.form.id_companies = res.data.store.id_companie;
            this.form.id_client = this.id_client;
            this.redirect = 'https://vinapp.co/'+res.data.store.uri;
            this.name_client = res.data.store.name_client;
            this.backgroundColor = res.data.store.color_letra;
					}
  			}).catch(err => {
		      console.log(err);      
		    });
  		},
  		border(puntero){
  			this.form.estado=puntero
  			var elemento = document.getElementById("like");
  			var elemento2 = document.getElementById("dislike");
        if (puntero) {
          elemento.className = "option-1 border"; 
          elemento2.className = "option-2";
        }else{
          this.form.observation="";
          elemento.className = "option-1"; 
          elemento2.className = "option-2 border";
        }
        
  		},
  		saveQrSurvey(){  
  		  var self = this;
  			axios.post("https://back.vinapp.co/api/save-qr-survey",this.form)
  			.then(res => {
					if (res.data.statusCode == 200) {
						//console.log(this.form)
					  setTimeout(function(){  window.open(self.redirect,'_self')}, 2000);
					}
  			}).catch(err => {
		      console.log(err);      
		    });
  		},
		},
		mounted() {  
			var self = this;
			self.border(true);
			setTimeout(function(){ self.setupCompanieQuestions();  }, 1000);
		      
		}
   }
</script>